import axios from 'axios';
import { API_URL } from '../config/api.config';

const getAuthInfo = () => {
    const garageId = JSON.parse(localStorage.getItem('user') || '{}')._id || ''
    const token = localStorage.getItem('token');
    return { garageId, token };
};

const createAuthAxios = () => {
    const { token } = getAuthInfo();
    return axios.create({
        baseURL: API_URL,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};
const authAxios = createAuthAxios()

export interface ReviewResponse {
    content: string;
    createdAt: Date;
    updatedAt: Date;
}

export interface Review {
    _id: string;
    clientId: string;
    clientName: string;
    garageId: string;
    rating: number;
    title: string;
    content: string;
    status: 'PENDING' | 'APPROVED' | 'REJECTED' | 'REPORTED';
    categories: string[];
    createdAt: Date;
    updatedAt: Date;
    response?: ReviewResponse;
    helpfulCount: number;
    isVerified: boolean;
}

export interface ReviewStats {
    averageRating: number;
    totalReviews: number;
}

export interface ReviewListResponse {
    reviews: Review[];
    pagination: {
        total: number;
        page: number;
        limit: number;
        pages: number;
    };
    stats: ReviewStats;
}

export const reviewService = {
    // Récupérer tous les avis pour un garage
    async getGarageReviews(garageId: string, options?: { status?: string; page?: number; limit?: number; sort?: string }): Promise<ReviewListResponse> {
        try {
            const params = new URLSearchParams();

            if (options?.status && options.status !== 'all') {
                params.append('status', options.status.toUpperCase());
            }

            if (options?.page) {
                params.append('page', options.page.toString());
            }

            if (options?.limit) {
                params.append('limit', options.limit.toString());
            }

            if (options?.sort) {
                params.append('sort', options.sort);
            }

            const response = await authAxios.get(`/reviews/garage/${garageId}?${params.toString()}`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la récupération des avis:', error);
            throw error;
        }
    },

    // Obtenir les statistiques des avis pour un garage
    async getGarageReviewStats(garageId: string): Promise<any> {
        try {
            const response = await authAxios.get(`/reviews/garage/${garageId}/stats`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la récupération des statistiques d\'avis:', error);
            throw error;
        }
    },

    // Obtenir un avis spécifique par ID
    async getReviewById(reviewId: string): Promise<Review> {
        try {
            const response = await authAxios.get(`/reviews/${reviewId}`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la récupération de l\'avis:', error);
            throw error;
        }
    },

    // Répondre à un avis
    async respondToReview(reviewId: string, garageId: string, content: string): Promise<Review> {
        try {
            const response = await authAxios.post(`/reviews/${reviewId}/respond`, {
                garageId,
                content
            });
            return response.data.review;
        } catch (error) {
            console.error('Erreur lors de l\'envoi de la réponse:', error);
            throw error;
        }
    },

    // Marquer un avis comme utile
    async markReviewAsHelpful(reviewId: string, userId: string): Promise<any> {
        try {
            const response = await authAxios.post(`/reviews/${reviewId}/helpful`, {
                userId
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors du marquage de l\'avis comme utile:', error);
            throw error;
        }
    },

    // Signaler un avis
    async reportReview(reviewId: string, userId: string, reason: string, details?: string): Promise<any> {
        try {
            const response = await authAxios.post(`/reviews/${reviewId}/report`, {
                userId,
                reason,
                details
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors du signalement de l\'avis:', error);
            throw error;
        }
    }
};